import { Configuration } from "../context/ConfigurationContext";
import { VenueUIConfigOptions } from "../types/Config";
import { createDisplayConfig, getPalette } from "./ThemeUtil";

export const getStrikeZoneConfig = (uiConfig: VenueUIConfigOptions, pitchersView?: string): Configuration => {
  return {
    scaling: {
      height: 540,
      width: 420,
      multiplier: 0.5,
    },
    palette: getPalette(uiConfig.theme),
    display: createDisplayConfig(uiConfig, pitchersView),
  };
};
